import { render, staticRenderFns } from "./ProductModal.vue?vue&type=template&id=9149c8ae&scoped=true&"
import script from "./ProductModal.vue?vue&type=script&lang=js&"
export * from "./ProductModal.vue?vue&type=script&lang=js&"
import style0 from "./ProductModal.vue?vue&type=style&index=0&id=9149c8ae&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9149c8ae",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\Globaltask\\Documents\\Happybox Store\\Happybox Site\\collection-gifting\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('9149c8ae')) {
      api.createRecord('9149c8ae', component.options)
    } else {
      api.reload('9149c8ae', component.options)
    }
    module.hot.accept("./ProductModal.vue?vue&type=template&id=9149c8ae&scoped=true&", function () {
      api.rerender('9149c8ae', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "CollectionGifting/components/GOCPreview/Tier/ProductModal.vue"
export default component.exports